/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Resources_Guide_Analysis_TitleInputs */

const en_gc_resources_guide_analysis_title = /** @type {(inputs: Gc_Resources_Guide_Analysis_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Turn a table into a clearer picture.`)
};

const zh_gc_resources_guide_analysis_title = /** @type {(inputs: Gc_Resources_Guide_Analysis_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`让表格信息更清晰。`)
};

/**
* | output |
* | --- |
* | "Turn a table into a clearer picture." |
*
* @param {Gc_Resources_Guide_Analysis_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_resources_guide_analysis_title = /** @type {((inputs?: Gc_Resources_Guide_Analysis_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Resources_Guide_Analysis_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_resources_guide_analysis_title(inputs)
	return zh_gc_resources_guide_analysis_title(inputs)
});
export { gc_resources_guide_analysis_title as "gc.resources.guide.analysis.title" }